import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const LineItemExchangeInfo = ({ item, cancelled }) => {
  const theme = useTheme()

  return (
    <Styles.Container cancelled={cancelled}>
      <Styles.ProductImage src="/images/placeholderImg.png" />
      <Text type="bodySRegular" color={theme.colors.text.muted}>
        {item?.exchange_info}
      </Text>
    </Styles.Container>
  )
}

export default LineItemExchangeInfo
